import { executeRequest } from '@utils/requests'

export type SecuritySettings = {
  twoFactorMethod: 'sms' | 'authenticator'
  authenticatorEnabled: boolean
  backupCodesRemaining: number
  cellphoneNumber: string | null
  paths: SecuritySettingsPaths
  backupCodes?: string[]
}

export type SecuritySettingsPaths = {
  enrolAuthenticatorPath: string
  confirmAuthenticatorPath: string
  disableAuthenticatorPath: string
  regenerateBackupCodesPath: string
}

export type Enrolment = {
  qrCodeSvg: string
  secret: string
  provisioningUri: string
}

export const startEnrolment = (paths: SecuritySettingsPaths): Promise<Enrolment> =>
  executeRequest(paths.enrolAuthenticatorPath, 'POST')

export const confirmEnrolment = (paths: SecuritySettingsPaths, code: string): Promise<SecuritySettings> =>
  executeRequest(paths.confirmAuthenticatorPath, 'POST', JSON.stringify({ code }))

export const regenerateBackupCodes = (paths: SecuritySettingsPaths): Promise<SecuritySettings> =>
  executeRequest(paths.regenerateBackupCodesPath, 'POST')

export const disableAuthenticator = (paths: SecuritySettingsPaths): Promise<SecuritySettings> =>
  executeRequest(paths.disableAuthenticatorPath, 'DELETE')
